export default __webpack_public_path__ + "static/media/img_lg.7d50cc45.svg";